import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TmwArabicTextareaComponent } from '@shared/components/arabic-textarea/arabic-textarea.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { TmwArabicInputComponent } from './components/arabic-input/arabic-input.component';
import { TmwCheckConsultComponent } from './components/check-consult/check-consult.component';
import { TmwDateEditComponent } from './components/date-time/date-edit/date-edit.component';
import { TmwDateRangeComponent } from './components/date-time/date-range/date-range.component';
import { TmwDatetimeEditComponent } from './components/date-time/datetime-edit/datetime-edit.component';
import { TmwTimeEditComponent } from './components/date-time/time-edit/time-edit.component';
import { TmwFileDownloadComponent } from './components/file/file-download/file-download.component';
import { TmwFileUploadComponent } from './components/file/file-upload/file-upload.component';
import { TmwI18NLabelComponent } from './components/i18n-label/i18n-label.component';
import { MultiSelectEditComponent } from './components/multi-select/multi-select-edit.component';
import { TmwNumberRangeComponent } from './components/number-range/number-range.component';
import { SearchErrorMessageComponent } from './components/search-errorMessage/search-errorMessage.component';
import { TmwDropdownCmp } from './components/select-referentiel/dropdown.component';
import { TranslateFieldComponent } from './components/tranlate-field/tranlate-field.component';
import { TmwValidationMessageComponent } from './components/validation-message/validation-message.component';
import { TmwConsultActionsComponent } from './components/consult-actions/consult-actions.component';
import { HasAnyAccessDirective } from './directives/has-any-access.directive';
import { HasAnyRoleDirective } from './directives/has-any-role.directive';
import { InvalidControlScrollDirective } from './directives/invalid-control-scroll.directive';
import { IsLangDirective } from './directives/is-lang.directive';
import { NgbdSortableHeader } from './directives/sortable.directive';
import { TmwTranslateDirective } from './directives/translate.directive';
import TmwAbbreviate from './pipes/abbreviate.pipe';
import TmwDatePipe from './pipes/date.pipe';
import TmwDateTimePipe from './pipes/datetime.pipe';
import { TmwDurationFormatPipe } from './pipes/duration.pipe';
import { TmwFilterPipe } from './pipes/filter.pipe';
import { NumberToWordsPipe } from './pipes/numberToWords.pipe';
import { ReferenceFonciereRangePipe } from './pipes/reference-fonciere-range.pipe';
import { TmwSafeHtmlPipe } from './pipes/safeHtml.pipe';
import TmwTimePipe from './pipes/time.pipe';
import TmwTranslatePipe from './pipes/translate.pipe';
import { ProfileCardComponent } from './components/profile-card/profile-card.component';
import { SeveritePipe } from './pipes/SeveritePipe';
import { LoadSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { TmwFileSizePipe } from './pipes/file-size.pipe';
import { TmwTabsComponent } from './components/reusable-tabs/reusable-tabs.component';
import { TmwSwitchInputComponent } from './components/switch-input/switch-input.component';
import { TmwExportListComponent } from './components/export-list/export-list.component';
import { CheckboxComponent } from './components/checkbox-input/checkbox-input.component';
import { TrimTextDirective } from './directives/trim-text-directive';
import { ChipsInputComponent } from './components/chips-input/chips-input.component';
import { AuditHistoryComponent } from './components/audit-history/audit-history.component';

@NgModule({
  imports: [
    TmwTranslateDirective,
    TmwFilterPipe,
    TmwDatePipe,
    TmwDateTimePipe,
    TmwTimePipe,
    TmwDurationFormatPipe,
    TmwTranslatePipe,
    TranslateFieldComponent,
    TmwAbbreviate,
    IsLangDirective,
    TrimTextDirective,
    RouterLink,
    TmwCheckConsultComponent,
    TmwNumberRangeComponent,
    TmwDateRangeComponent,
    TmwDateEditComponent,
    TmwDatetimeEditComponent,
    TmwTimeEditComponent,
    TmwDropdownCmp,
    TmwSwitchInputComponent,
    CheckboxComponent,
    TmwExportListComponent,
    TmwValidationMessageComponent,
    MultiSelectEditComponent,
    TmwFileUploadComponent,
    TmwFileDownloadComponent,
    SearchErrorMessageComponent,
    TmwArabicInputComponent,
    TmwArabicTextareaComponent,
    ChipsInputComponent,
    HasAnyRoleDirective,
    HasAnyAccessDirective,
    TmwConsultActionsComponent,
    InvalidControlScrollDirective,
    TmwI18NLabelComponent,
    TmwSafeHtmlPipe,
    NumberToWordsPipe,
    BreadcrumbsComponent,
    ReferenceFonciereRangePipe,
    ProfileCardComponent,
    SeveritePipe,
    LoadSpinnerComponent,
    NgbdSortableHeader,
    TmwFileSizePipe,
    TmwTabsComponent,
    NgbModule,
    NgbModalModule,
    AuditHistoryComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgbdSortableHeader,
    NgSelectModule,
    TmwTranslateDirective,
    TmwFilterPipe,
    TmwDatePipe,
    TmwDateTimePipe,
    TmwTimePipe,
    TmwDurationFormatPipe,
    TmwTranslatePipe,
    TranslateFieldComponent,
    TmwAbbreviate,
    IsLangDirective,
    TrimTextDirective,
    TmwCheckConsultComponent,
    TmwNumberRangeComponent,
    TmwDateRangeComponent,
    TmwDateEditComponent,
    TmwDatetimeEditComponent,
    TmwTimeEditComponent,
    TmwDropdownCmp,
    TmwSwitchInputComponent,
    CheckboxComponent,
    TmwExportListComponent,
    TmwValidationMessageComponent,
    MultiSelectEditComponent,
    TmwFileUploadComponent,
    TmwFileDownloadComponent,
    RouterLink,
    TmwArabicInputComponent,
    TmwArabicTextareaComponent,
    ChipsInputComponent,
    HasAnyRoleDirective,
    HasAnyAccessDirective,
    TmwConsultActionsComponent,
    InvalidControlScrollDirective,
    SearchErrorMessageComponent,
    TmwI18NLabelComponent,
    TmwSafeHtmlPipe,
    NumberToWordsPipe,
    BreadcrumbsComponent,
    ReferenceFonciereRangePipe,
    ProfileCardComponent,
    SeveritePipe,
    LoadSpinnerComponent,
    TmwFileSizePipe,
    TmwTabsComponent,
    NgbModalModule,
    AuditHistoryComponent,
  ],
})
export class SharedModule {}
